import { Helmet } from 'react-helmet';

const Seo = ({
  title,
  description,
  keywords,
  image,
  url,
}: {
  title: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      {image && <meta property="og:image" content={image} />}
      {url && <link rel="canonical" href={url} />}
    </Helmet>
  );
};

export default Seo;
